import React from 'react';
import Typography from '@mui/material/Typography';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import Box from '@mui/material/Box';
import { useDashboardCountsContext } from '@/dashboard/provider/DashboardCountsProvider';
import { convertTimestampToDate } from '@/common/utils/date.utils';

interface ContributionMetaStatusProps {
  bypassApprovalDate: string;
  period: string;
}

function BypassApprovalDate({ period, bypassApprovalDate }: ContributionMetaStatusProps) {
  const { bandDetails } = useDashboardCountsContext();
  const periodBandDetails = bandDetails[period];

  const color = periodBandDetails.label === 'Accepted' ? 'primary.main' : 'custom.errorContent';
  return (
    <Box display="flex" alignItems="center" gap={2}>
      <AltRouteIcon fontSize="small" sx={{ color, height: 16, width: 16 }} />
      <Typography variant="caption" color={color}>
        {`Bypass Approved ${convertTimestampToDate(bypassApprovalDate)}`}
      </Typography>
    </Box>
  );
}

export default BypassApprovalDate;
